// API 配置 - 只连接 Java 后端
// 使用相对路径，让 package.json 中的 proxy 配置生效
// 开发环境会代理到 http://localhost:8080
export const API_CONFIG = {
  BASE_URL: '',
};

// API 端点
export const API_ENDPOINTS = {
  // 认证
  AUTH: {
    REGISTER: '/user/register',
    LOGIN: '/user/login',
    SEND_CODE: '/user/send-verification-code',
  },
  // 文件
  FILES: {
    INIT_UPLOAD: '/files/init-upload',
    COMPLETE_UPLOAD: '/files/complete-upload',
  },
  // 任务
  TASK: {
    CREATE_DRAFT: '/task/create-draft',
    STATUS: '/task/status',
    LIST: '/task/list',
    RESULT: '/task/result',
  },
  // 会议纪要
  NOTE: {
    LATEST: '/note/latest',
    VERSIONS: '/note/versions',
  },
  // 热词
  HOT_WORDS: {
    LIST: '/hotwords/list',
  },
  // 邀请
  INVITATION: {
    MY_CODE: '/invitation/my-code',
    RECORDS: '/invitation/records',
  },
  // 用户
  USER: {
    PROFILE: '/user/profile',
  },
  // 文件夹
  FOLDER: {
    LIST: '/folder/list',
    CREATE: '/folder/create',
    RENAME: '/folder',
    DELETE: '/folder',
    MOVE_TASK: '/folder/move-task',
    TASKS: '/folder',
  },
};
